module.exports = __webpack_public_path__ + "media/images/icon/navigation/dashboard-f8587e71de9d009b329611fa1d6fed6a.svg";